<mat-card class="sx-tips-item">
    <mat-card-header>
        <mat-card-title>{{ tip.title }}</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <ng-container *ngIf="!!tip.tags">
            <div class="sx-tips-tags">
                <div *ngFor="let tag of tip.tags" class="sx-chip">{{ tag }}</div>
            </div>
        </ng-container>
        <div [innerHtml]="tip.message | safeHtml" class="sx-tips-item-content"></div>
    </mat-card-content>
    <mat-card-actions>
        <button *ngIf="!!tip.url" mat-button id="tip_navigate_to_btn" (click)="onNavigateClick()">
            <span>{{ 'core.header.tips.navigate-to-button' | translate }}</span>
        </button>
        <button *ngIf="!tip.isRead" mat-button id="tip_hide_btn" (click)="onHideClick()">
            <span>{{ 'core.header.tips.hide-button' | translate }}</span>
        </button>
    </mat-card-actions>
</mat-card>